import { Phone } from 'lucide-react';

import { EmptyResult } from '@/components/empty-result';
import { ProtectedComponent } from '@/components/ProtectedComponent';

import { emit } from '@/hooks/use-event-handler';

import { Permissions } from '@/constants';

import { useSchedulerListStore } from '@/store/schedule.store';

export const BatchCallEmptyResult = () => {
  const { query, reset, filters } = useSchedulerListStore();

  const hasQuery = (query && query.trim() !== '') || filters.status !== 'All';

  const title = hasQuery
    ? 'No batch calls found for the selected search criteria or filters'
    : 'No batch calls created yet.';
  const description = hasQuery
    ? 'Adjust or clear filters to view available batch calls.'
    : 'Create batch calls to automatically call multiple recipients.';

  return (
    <ProtectedComponent
      requiredPermissions={[Permissions.BatchCallCreateUpdate]}
      fallback={
        <EmptyResult
          icon={<Phone className="h-12 w-12 text-muted-foreground/40" />}
          title={title}
        />
      }
    >
      <EmptyResult
        icon={<Phone className="h-12 w-12 text-muted-foreground/40" />}
        title={title}
        hasQuery={hasQuery}
        onClear={reset}
        description={description}
        onCreate={() => emit('batch-calls:create')}
        createButtonText="Create a batch call"
      />
    </ProtectedComponent>
  );
};
